import { render, staticRenderFns } from "./vCopyRecipeModal.vue?vue&type=template&id=76be24be&scoped=true"
import script from "./vCopyRecipeModal.vue?vue&type=script&lang=ts"
export * from "./vCopyRecipeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76be24be",
  null
  
)

export default component.exports